import { ProjectFormDto, type ProjectFormInterface } from '@zaoblako/shared/modules/project/dto/project/project-form.dto';
import { SubprojectDefaultsFormDto, type SubprojectDefaultsFormInterface } from '@zaoblako/shared/modules/project/dto/subproject-defaults/subproject-defaults-form.dto';
import { ChecklistFormDto, type ChecklistFormInterface } from '@zaoblako/shared/modules/project/dto/checklist/checklist-form.dto';
import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { ProjectDtoKeysEnum } from '@zaoblako/shared/modules/project/enum/project-dto-keys.enum';
import { entityLikeSchema } from '@zaoblako/shared/modules/serde/schemas/entity-like.schema';
import { ProjectCheckersEnum } from '@zaoblako/shared/modules/project/enum/project-checkers.enum';
import type { ProjectTemplateFindInterface } from '@zaoblako/shared/modules/project/dto/template/project-template-find.dto';
import type { BudgetRequestFindInterface } from '@zaoblako/shared/modules/task/dtos/budget-request/budget-request-find.dto';
import type { FileFindInterface } from '@zaoblako/shared/modules/storage/dtos/file/file-find.dto';

import * as yup from 'yup';

/** Project create API request body - DTO signature */
export interface ProjectCreateInterface extends ProjectFormInterface {
  /** Project template to fill data */
  template?: ProjectTemplateFindInterface;
  /** Default values for sub-projects */
  subprojectDefaults?: SubprojectDefaultsFormInterface;
  /** Budget requests to assign */
  budgetRequests?: BudgetRequestFindInterface[];
  /** Files to attach */
  files?: FileFindInterface[];
  /** Checklists to create */
  checklists?: ChecklistFormInterface[];
}

/** Project create API request body - DTO schema */
export const ProjectCreateDto = SerdeDtoClass.from<ProjectFormInterface, ProjectCreateInterface>(
  ProjectFormDto,
  ProjectDtoKeysEnum.PROJECT_CREATE_DTO,
  {
    template: {
      optional: true,
      label: 'Шаблон',
      serializer: entityLikeSchema,
      checkers: [ProjectCheckersEnum.PROJECT_TEMPLATE_ASSERT_EXISTS_BY_DTO],
    },
    subprojectDefaults: {
      optional: true,
      label: 'Реквизиты по-умолчанию для подзадач',
      nested: SubprojectDefaultsFormDto,
      serializer: (_, nested) => nested,
    },
    checklists: {
      optional: true,
      label: 'События',
      nested: ChecklistFormDto,
      serializer: (_, nested) => yup.array(nested),
    },
  },
);
